<template>
  <v-container>
    <v-toolbar class="transparent elevation-0">
      <v-toolbar-title>{{ greeting }}</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap>
      <template v-for="workarea in workareas">
        <v-flex
          v-if="workarea.has_access"
          :key="workarea.title"
          xl3
          lg4
          md6
          sm6
          xs12
          pa-3
        >
          <card-workarea v-bind="workarea" />
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import { STORE_USER_NAME, STATE_PROFILE } from "@/store_constants/user";
import CardWorkarea from "./components/CardWorkarea.vue";
import { checkUserPermissions } from "@/utils/userPermissionsControl";
import { STATE_PERMISSIONS_BY_CATEGORY, STORE_PERMISSIONS_NAME } from "@/store_constants/permissions";
export default {
  components: { CardWorkarea },
  computed: {
    greeting() {
      var now = new Date();

      return `Good ${now.getHours() < 12 ? "morning" : "afternoon"} ${
        this.profile.name
      }!`;
    },
    ...mapState(STORE_USER_NAME, {
      profile: STATE_PROFILE
    }),
    ...mapState(STORE_PERMISSIONS_NAME, {
      permissionsByCategory: STATE_PERMISSIONS_BY_CATEGORY
    }),
    workareas() {
      return [
        {
          title: "Content Explorer",
          subtitle:
            "Explore all available contents available in PLANT, organized in folders.",
          icon: "mdi-folder-multiple-outline",
          has_access: true,
          to: "explorer"
        },
        {
          title: "Training Catalog",
          subtitle: "Browse and enroll to available training courses",
          icon: "mdi-google-classroom",
          has_access: true,
          to: "training"
        },
        {
          title: "Workflows",
          subtitle:
            "Create, review and approve content before it goes into the content explorer",
          icon: "mdi-clipboard-check-outline",
          has_access: this.canShowWorkflowsSection(),
          to: "workflows"
        },
        {
          title: "Configuration Control",
          subtitle:
            "Keep all your approved content under control. Update your content to use always the latest revisions of the references it is using.",
          icon: "mdi-police-badge-outline",
          has_access: this.canShowConfigurationControlSection(),
          to: "configuration"
        },
        {
          title: "Content Tools",
          subtitle:
            "In this section you will find tools to execute operations on the contents.",
          icon: "mdi-hammer-wrench",
          has_access: this.canShowContentToolsSection(),
          to: "tools"
        }
      ];
    }
  },
  methods: {
		canShowWorkflowsSection() {
			const permissions = [
				this.permissionsByCategory.workflowManagement.editViewWorkflowDrafts,
				this.permissionsByCategory.workflowManagement.changeWorkflowType,
				this.permissionsByCategory.workflowManagement.reassignWorkflowRoles
			];

			return permissions.some(permission => checkUserPermissions([permission]));
		},
		canShowConfigurationControlSection() {
			const permissions = [this.permissionsByCategory.contentManagement.manageAdminTools];

			return checkUserPermissions(permissions);
		},
		canShowContentToolsSection() {
			const permissions = [this.permissionsByCategory.contentManagement.manageAdminTools];

			return checkUserPermissions(permissions);
		}
  }
};
</script>

